<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import type { INavigationItem } from '@/components/common/ElNavigation/elNavigation';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import HorizontalNavigation from '@/components/navigation/HorizontalNavigation/HorizontalNavigation.vue';
  import { ROUTE_NAME_CUSTOMER_TRIPS_DATED, ROUTE_NAME_CUSTOMER_TRIPS_TEMPLATE } from '@/config/routeNames';
  import { customerPage } from '@/cypaths';
  import ContextualHelp from '@/components/common/ContextualHelp/ContextualHelp.vue';
  import { CONTEXT_HELP_SERVICE_REQUESTS_LIST } from '@/config';

  defineOptions({ name: 'CustomerTripsView', inheritAttrs: false });

  const { t } = useI18n();
  const tripListMenuItems = computed<INavigationItem[]>(() => [
    {
      label: t('pages.customerTrips.navigation.nextTripsLabel'),
      to: { name: ROUTE_NAME_CUSTOMER_TRIPS_DATED },
    },
    {
      label: t('pages.customerTrips.navigation.regularTripsLabel'),
      to: { name: ROUTE_NAME_CUSTOMER_TRIPS_TEMPLATE },
    },
  ]);
</script>

<template>
  <PageContent
    class="gap-6 md:gap-10 pb-14 md:pb-14"
    v-bind="$attrs"
    :data-cy="customerPage.TRIPS_CONTENT"
  >
    <template #header>
      <div class="flex flex-row items-center md:container justify-between md:justify-center relative">
        <h1 class="print:hidden">
          {{ t('generic.manageMyBookings') }}
        </h1>
        <span class="h1 not-print:hidden">{{ t('pages.customerTrips.printTitle') }}</span>
        <ContextualHelp
          :help-id="CONTEXT_HELP_SERVICE_REQUESTS_LIST"
          display-type="modal"
          class="pl-1 md:absolute md:right-0"
        />
      </div>
    </template>
    <template #navigation>
      <nav
        :aria-label="t('generic.manageMyBookings')"
        class="border-b border-gray-light bg-white md:container"
      >
        <HorizontalNavigation
          wide-items
          :items="tripListMenuItems"
          class="flex"
          match-exact
          :data-cy="customerPage.CUSTOMER_TRIPS_NAVIGATION"
        />
      </nav>
    </template>
    <RouterView />
  </PageContent>
</template>
